import { Stack, Typography } from '@mui/material'
import { activityPhases } from '@/features/chat/phase1/activityPhases'
import ActivityPhase from './ActivityPhase'

export default function ActivityPhaseList({
  rows = [],
  trimmed = false,
  streaming = false,
  citations = [],
}) {
  const phases = activityPhases(rows)
  return (
    <Stack sx={{ gap: 0, mt: 0.75 }}>
      {trimmed ? (
        <Typography sx={{ fontSize: 'var(--app-thought-font-size)', color: 'var(--app-text-tertiary)' }}>
          Earlier steps not retained
        </Typography>
      ) : null}
      {phases.map((phase) => (
        <ActivityPhase
          key={`${phase.id}:${phase.rows[0].id}`}
          phase={phase}
          streaming={streaming}
          citations={citations}
        />
      ))}
    </Stack>
  )
}
